/*
 * Actions file for Main State.
 *
 * TO LAUCH COMMIT OVER THE MUTATIONS FUNCTIONS
 * - RULES:
 *   - NOT DIRECT STATE MODIFICATIONS
 *   - ALL BUSINESS LOGIC NEEDED BASED ON THE STATE AND NEW/MOD INFO
 *   - CAN CONTAIN ASYNC API CALLS
 *
 */

/*
 * TO CALL THIS ACTION FROM COMPONENT .VUE:
 *  - within the methods section in a method
 *  - call: this.$store.dispatch('addProductToCart', this.product);
 * */

import jllLocalstorageManager from 'jll-localstorage-manager';
import Console from '@/shared/console';
import pixAxios from '@/axios/pixAxios';
import i18nOptions from '@/services/i18n/i18nOptions.utils';

export const setLangCode = function ({ commit }, langCode) {
  localStorage.setItem(i18nOptions.langCodeKey, JSON.stringify(langCode));
  commit('langCode', langCode);
};

export const setTranslationIsLoaded = function ({ commit }, translationIsLoaded) {
  commit('translationIsLoaded', translationIsLoaded);
};

export const setShowApp = function ({ commit }, showApp) {
  commit('showApp', showApp);
};

export const changeInstance = async function ({ dispatch, getters }, instance) {
  const instanceModel = {
    UserName: getters['authModule/UserName'],
    NewInstance: instance,
  };

  try {
    const response = await pixAxios.put('api/Users/ChangeUserInstance', instanceModel);
    if (response.status === 200) {
      await dispatch('authModule/unloadPixAuthToken');
      window.location.reload();
    } else {
      dispatch('toastModule/error', 'Instance change error', { root: true });
    }
  } catch (error) {
    Console.log(error);
  }
};

export const componentsActivation = function ({ state, commit }, updateComponent) {
  if (updateComponent) {
    // Update activation of a component in state object
    const oldState = state.componentsActivation.find((f) => f.component === updateComponent.component);
    if (oldState) {
      // Update
      oldState.isActive = updateComponent.isActive;
    } else {
      // Add
      state.componentsActivation.push(updateComponent);
    }
    jllLocalstorageManager.set('componentsActivation', state.componentsActivation, 1000 * 3600 * 24 * 365);
    commit('componentsActivation', state.componentsActivation);
  } else {
    // Look into local storage
    const storedComponentsActivation = jllLocalstorageManager.get('componentsActivation');
    // Set default values
    if (!storedComponentsActivation || storedComponentsActivation.length === 0) {
      const defaultComponentsActivation = [
        {
          component: 'Comparables',
          isActive: true,
        },
        {
          component: 'PortfolioComparables',
          isActive: false,
        },
        {
          component: 'ComparablesBasket',
          isActive: true,
        },
        {
          component: 'AreaOfInterest',
          isActive: true,
        },
        {
          component: 'Indicators',
          isActive: false,
        },
      ];
      // Save into local storage
      jllLocalstorageManager.set('componentsActivation', defaultComponentsActivation, 1000 * 3600 * 24 * 365);
      // Commit
      commit('componentsActivation', defaultComponentsActivation);
    } else {
      // Commit
      commit('componentsActivation', storedComponentsActivation);
    }
  }
};

export const setMode = function ({ commit }, mode) {
  commit('setMode', mode);
};
